import MessageTranslation from '@/modules/i18n/model/MessageTranslation'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import Locale from '@/modules/i18n/model/Locale';

/**
 * Mensaje
 */
export default class Message {
    public id: number = -1
    public key: string = ''
    public content: string = ''
    public locale: Locale | string = ''
    public createdAt: number = 0
    public updatedAt: number = 0
    public richFormat = false
    public translations: MessageTranslation[] = []

    constructor (key = '', content = '', locale = '') {
        this.key = key
        this.content = content
        this.locale = locale
    }

    /**
     * Permite obtener una traducción en base a un localismo
     *
     * @param locale
     */
    public translate (locale: string): MessageTranslation | null {
        return this.translations.find(t => t.locale === locale) || null
    }

    /**
     * Añade una traducción a la lista de traducciónes o la reemplaza si
     * ya existe
     *
     * @param translation
     */
    public addTranslation (translation: MessageTranslation) {
        if (!translation.locale) {
            throw new Error('La traducción argumentada debe tener un idioma')
        }

        const index = this.translations.findIndex(t => t.locale === translation.locale)
        if (index > -1) {
            this.translations.splice(index, 1, translation)

            return
        }

        this.translations.push(translation)
    }

    public serialize (): KeyValuePair {
        return {
            key: this.key,
            rich_format: this.richFormat,
            translations: this.translations.map(t => t.serialize()),
        }
    }

    public static convert (data: {[key: string]: any}): Message {
        const message = new Message(data.key, data.message, data.locale)
        message.id = data.id
        message.createdAt = parseInt(data.created_at, undefined)
        message.updatedAt = parseInt(data.updated_at, undefined)
        message.richFormat = data.rich_format
        message.translations = data.translations.map((t: KeyValuePair) => MessageTranslation.deserialize(t))

        return message
    }
}
